import React, { useEffect } from "react";
import UserAppBar from "../common/UserAppBar";
import { Container } from "@mui/material";
import { Row2, Rowworker1 } from "../../../components/Row";
import { mainColor, subColor1, whiteColor } from "../../../assets/colors/color";
import { ShipTitle } from "../../../components/ShipTitle";
import { useLocation } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { format, parseISO } from "date-fns";
import { getScheduleShip } from "../../../recoil/GetData";
import { NoteTextListText } from "../../../components/Note";
import { loginAuthenticationUser } from "../../../hooks/loginAuthentication";
//선박 작업일정 기선STS
function UserShipScheduleSteamship() {
  const location = useLocation();
  const shipInfo = { ...location.state };
  const journeyDetailId = shipInfo.journeyDetailId;

  const shipApi = useRecoilValue(
    getScheduleShip(`sts?journeyDetailId=${journeyDetailId}`)
  );
  console.log(shipApi);

  const noteList = shipApi.noteList;
  const noteList2 = [...noteList];
  const noteList3 =
    noteList2 &&
    noteList2.sort(
      (a, b) =>
        new Date(`${a.writtenAt.substr(0, 10)}T${a.writtenAt.substr(11)}`) -
        new Date(`${b.writtenAt.substr(0, 10)}T${b.writtenAt.substr(11)}`)
    );

  useEffect(() => {
    loginAuthenticationUser();
  }, []);

  return (
    <div>
      <UserAppBar />
      <Container
        maxWidth="sm"
        sx={{
          marginTop: "76px",
          marginBottom: "20px",
          gap: "10px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ShipTitle
          Step={shipApi.status}
          ShipName={shipApi.ship}
          Date={format(parseISO(shipApi.workStartAt), "yyyy / MM / dd")}
          color={`${subColor1}`}
        />
        <div
          style={{
            width: "100%",
            borderTop: `2px solid ${mainColor}`,
            borderBottom: `2px solid ${mainColor}`,
            marginTop: 10,
          }}
        >
          <Row2 Tilte={"항차"} Desc={shipApi.voyageNumber} />
          <Row2 Tilte={"용선주"} Desc={shipApi.charterer} />
          <Row2 Tilte={"화물"} Desc={shipApi.cargo} />
          <Row2 Tilte={"수량"} Desc={shipApi.amount} />
          <Row2
            Tilte={"구분"}
            Desc="기선간 STS"
            bgcolor={`${mainColor}`}
            TitleColor={`${whiteColor}`}
            Desxcolor={`${whiteColor}`}
          />
          <Row2 Tilte={"작업지"} Desc={shipApi.berthingPlace} />
          <Row2
            Tilte={"작업선명"}
            Desc={`${shipApi.motherShip}-${shipApi.sonShip}`}
          />
          <Row2
            Tilte={"시작일시"}
            Desc={format(parseISO(shipApi.workStartAt), "yyyy-MM-dd HH:mm")}
          />
          <Row2
            Tilte={"완료일시"}
            Desc={format(parseISO(shipApi.workDoneAt), "yyyy-MM-dd HH:mm")}
          />
          <Row2 Tilte={"안전관리"} Desc={shipApi.safety} />
          <NoteTextListText noteList={noteList3} />
        </div>
        <div style={{ width: "100%", marginTop: 10 }}>
          <h1 style={{ fontSize: 22, textAlign: "center" }}>근무자 정보</h1>
          <div
            style={{
              borderBottom: `2px solid ${mainColor}`,
              marginTop: 10,
            }}
          >
            <Rowworker1
              Desc4={"기선 STS"}
              bgcolor={`${mainColor}`}
              color={`${whiteColor}`}
            />
            {shipApi.sailorList.length > 0 ? (
              shipApi.sailorList.map((data) => (
                <Rowworker1 Desc4={data.name} key={data.name} />
              ))
            ) : (
              <p>선원을 추가하세요</p>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
}

export default UserShipScheduleSteamship;
